var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('button',{staticClass:"back-to-top-button",attrs:{"title":"Back To Top"},on:{"click":_vm.scrollToTop}},[_c('img',{staticClass:"back-to-top-icon",attrs:{"src":"/images/icons/icon-arrow-up-white.svg","alt":"Back to top"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }